import {loadRoles, loadAppRoles} from "@/services/roles";

const state = () => ({
    rolesList: [],
    rolesAppList: [],
});

const actions = {
    async fetchRoles({commit}) {
        const {data: roles} = await loadRoles();
        commit('updateRolesList', roles);
    },
    async fetchAppRoles({commit}) {
        const {data: roles} = await loadAppRoles();
        commit('updateAppRolesList', roles);
    }
};

const mutations = {
    updateRolesList(state, roles) {
        state.rolesList = roles;
    },
    updateAppRolesList(state, roles) {
        state.rolesAppList = roles;
    },
};

const getters = {
    getRolesList(state) {
        return state.rolesList;
    },
    getAppRolesList(state) {
        return state.rolesAppList;
    }
};

export default {state, actions, mutations, getters};
